import {newsContentManager} from '../../../api/newsContentManager';
import NewsItem from '../../../api/newsItemEntity';
import { actionTypes } from '../../../common/constants/actionTypes';

import { httpCallStartAction } from '../../../middlewares/http/actions';

export const fetchWelcomePageNewsItemsAction = () => (dispatch: any) => {
  dispatch(httpCallStartAction());

  newsContentManager.fetchWelcomePageNewsItemsAsync()
    .then((newsItems) => {
      dispatch(fetchWelcomePageNewsItemsAsyncCompleted(newsItems));
    });
};

const fetchWelcomePageNewsItemsAsyncCompleted = (newsItems: NewsItem[]) => ({
  meta: {
    httpEnd: true,
  },
  payload: newsItems,
  type: actionTypes.FETCH_WELCOME_PAGE_NEWS_ITEMS_COMPLETED
});


// WEBPACK FOOTER //
// ./src/components/welcomePageNewsBlock/actions/fetchWelcomePageNewsItems.ts